import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.scss';
import MarketApp from './MarketApp';
import {HashRouter} from "react-router-dom";

ReactDOM.render(
    <React.StrictMode>
        <HashRouter>
            <MarketApp />
        </HashRouter>
    </React.StrictMode>,
    document.getElementById('root')
);
